import { put, call, takeEvery, takeLatest, all } from 'redux-saga/effects'
import addAppErrorLogEntry from '../../dataservices/addAppErrorLogEntry'
import { logError } from '../../utilities/Errors'

// NOTE RE: redux-saga/issues/1844
// There does seem to be a redux-saga bug here.
// According to https://redux-saga.js.org/docs/api/#putaction the put effect should not bubble up errors from reducers (etc), but it does seem to
// see https://github.com/redux-saga/redux-saga/issues/1844
// to avoid allowing success actions to be followed by fail actions from the saga if a downstream render throws, we will swallow the exception (which should not happen) here
// note that if the saga infrastructure has an exception it will be ignored here... I suppose that there are bigger problems though in that case

export function* processSaga(workflowActions, mainCallable, params) {
	try {
		try {
			// SEE NOTE RE: redux-saga/issues/1844
			yield put(workflowActions.begin({ ...params }))
		} catch (ex) {
			console.log('redux-saga/issues/1844', ex)
		}
		if (params.meta && params.meta.begin) {
			yield call(params.meta.begin, params)
		}
		const result = yield call(mainCallable, params)
		const nextParams = { ...params, ...result }
		try {
			// SEE NOTE RE: redux-saga/issues/1844
			yield put(workflowActions.success(nextParams))
		} catch (ex) {
			console.log('redux-saga/issues/1844', ex)
		}
		if (params.meta && params.meta.success) {
			yield call(params.meta.success, nextParams)
		}
		return nextParams
	} catch (error) {
		const nextParams = { ...params, error }
		try {
			// SEE NOTE RE: redux-saga/issues/1844
			yield put(workflowActions.fail(nextParams))
		} catch (ex) {
			console.log('redux-saga/issues/1844', ex)
		}
		if (params.meta && params.meta.fail) {
			yield call(params.meta.fail, nextParams)
		}
		throw error
	}
}

export function* chainSagas(workflows, params) {
	let chainParams = params
	for (const workflow of workflows) { // eslint-disable-line no-restricted-syntax
		const result = yield call(workflow, chainParams)
		chainParams = { ...chainParams, ...result }
	}
	return chainParams
}

export function* fanSagas(workflows, params) {
	const results = yield all(workflows.map((workflow => call(workflow, params))))
	return results.reduce((nextParams, result) => {
		// eslint-disable-next-line no-param-reassign, because this is exactly the right thing to be doing in a reducer
		nextParams = { ...nextParams, ...result } // N.B.: this will overwrite params in an undefined way if multiple sagas return the same key in the result
		return nextParams
	}, params)
}

export function* watchSaga(triggers, workflow, { shouldCall, selectParams, latest } = {}) {
	const taker = latest ? takeLatest : takeEvery
	if (!(Array.isArray(triggers) ? triggers.every(trigger => (typeof trigger === 'string')) : (typeof triggers === 'string'))) {
		logError('SAGA ERROR: watchSaga invalid trigger encountered', triggers)
	}
	yield taker(triggers, function* execWorkflow(action) {
		try {
			let params = action.payload ? { ...action.payload, meta: { ...action.payload.meta, ...action.meta } } : { meta: action.meta }
			if (shouldCall && !(yield call(shouldCall, params))) {
				return undefined
			}
			params = selectParams ? yield call(selectParams, params) : params
			const result = yield call(workflow, params)
			const nextParams = { ...params, ...result }
			return nextParams
		} catch (error) {
			//	Log the details
			logError(`SAGA ERROR: watchSaga ${action.type}`, error)
			addAppErrorLogEntry(action.type, action.payload, error, 'SAGA')
			return undefined
		}
	})
}



// WEBPACK FOOTER //
// ./src/redux/saga/workflow.js